// test2834
(2834 && 0);
